module.exports = "<p>\n  req-general-operario-ver works!\n</p>\n"